import { render } from "./sidebar.layout.vue?vue&type=template&id=2a14c23b"
import script from "./sidebar.layout.vue?vue&type=script&lang=js"
export * from "./sidebar.layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__